import { render, staticRenderFns } from "./ProjectOrigin.vue?vue&type=template&id=41718bc9&scoped=true&"
import script from "./ProjectOrigin.vue?vue&type=script&lang=js&"
export * from "./ProjectOrigin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41718bc9",
  null
  
)

export default component.exports